import React, { useEffect, useState } from "react";
import "../styles/home.css"
import { useAuthUser } from "../context/authuser";
import { useNavigate } from "react-router-dom";
import {
    UserIcon,
    ArrowLeftOnRectangleIcon,
    UserPlusIcon,
    ChatBubbleLeftRightIcon,
    MagnifyingGlassIcon,
    UserCircleIcon,

} from '@heroicons/react/24/outline'
import Chat from "./Chat";
import ProfileInfo from "./ProfileInfo";
import { Link } from "react-router-dom";
import { toast} from "react-toastify";
import { ChatBubbleLeftIcon } from "@heroicons/react/24/solid";

const Home = () => {
    const push = useNavigate();
    const [user, setUser] = useState({})
    const [search, setSearch] = useState("")
    const { liveUser, LogOut, dbUser, load,online} = useAuthUser();
    const [showName, setShowName] = useState({})
    const [profile, setProfile] = useState(false)
    const [contact, setContact] = useState(true)
 

    useEffect(() => {
        // eslint-disable-next-line array-callback-return
        const name = dbUser.filter((item) => {
            if (liveUser?.uid === item?.uid) {
                return item
            }
        })
        setShowName(...name)
    }, [dbUser, liveUser, liveUser?.uid])
 



    function userdata(id) {
        const data = dbUser.filter((item) => item.uid === id)
        setUser(...data)
    }

    // eslint-disable-next-line array-callback-return
    const data = dbUser.filter(post => {
        if (search === "") {
            return post;
        } else if (post.name.toLowerCase().includes(search.toLowerCase())) {
            return post;
        }
    });
  
    function SignOut() {
        LogOut().then(() => {
            push("/login")
            toast.success(
                "Logout Successfully 🙏🙏🙏"
               )
        })
    }

    useEffect(() => {
        if (!liveUser) {
            push('/login')
        }
    }, [liveUser, push])
    
    if (load) {
        return <div className="spin"></div>
    }

    return (
        <div>
            <div className="relative">
                <div className="tele"></div>

                <div className="full-width">
                    <div className="two-page">
                        <div className="chat">
                            <div className="out">
                                {showName?.photoURL ?
                                <>
                                {online ? <img className="icon-hero" onClick={() => setProfile((prev) => !prev)}  src={showName?.photoURL} alt="logo"></img>:
                               <img className="icon-false" onClick={() => setProfile((prev) => !prev)}  src={showName?.photoURL} alt="logo"></img>
                                
                                }
                                </>
                                  : <UserCircleIcon onClick={() => setProfile((prev) => !prev)} className="chat-box"/>
                                }

                                <div className="flex">
                                    <p className="hero-logo">Chat-lyy</p>
                                </div>
                                <div>
                                <Link to="/chat">
                                <div className="mobile">
                                    <ChatBubbleLeftRightIcon className="chat-box"/>
                                </div>
                                </Link>
                                </div>
                            </div>
                            {profile && (
                                <div className="hide">
                                    <div className="flex-bro">
                                        <UserIcon className="mini"></UserIcon>
                                        <p className="names">{showName?.name}</p>

                                    </div>
                                    <div className="flex-bro">
                                     <UserPlusIcon className="mini"/>
                                     <Link className="link" to="/profile">view profile</Link>
                                    </div>
                                    <div onClick={SignOut} className="flex-bro">
                                        <ArrowLeftOnRectangleIcon className="mini"></ArrowLeftOnRectangleIcon>
                                        <p className="names">LogOut</p>

                                    </div>
                                </div>
                            )}

                            <div className="search-icon">
                                <MagnifyingGlassIcon className="bi-search" />
                                <input type="search"
                                    className="search"
                                    placeholder="Search Profile"
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                            { data && data.map((item, index) => (
                                <Link to={`/mobile/${item.id}`} className="underline" onClick={() => userdata(item.uid)} key={index}>
                                    
                                    <div onClick={() => setContact(false)} className="user-profile">
                                        <div className="state">
                                      {item.photoURL ?
                                        <img className="size"  src={item.photoURL} alt="logo"/>
                                        : <UserCircleIcon className="size"/>
                                        }
                                            <div className="online">
                                                <div className="user-name">
                                                    <h4 className="msg-name">{item.name}</h4>
                                                    <p className="current-msg">{item.about?item.about:"set bio"}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            ))}

                        </div>
                        <div className="chat-mobile">
                            <Chat/>
                        </div>
                        <div className="profile-mobile">
                          <ProfileInfo user = {user} con = {contact} />
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Home;